<div class="min-h-dvh flex items-center justify-center bg-background-light px-6">
  <div class="max-w-md w-full text-center bg-white rounded-xl shadow-card-elevated p-8">
    <a href="/" class="inline-block mb-6">
      <img ngSrc="assets/images/logo_transparent_rectangle.png" alt="corpers.ng logo" class="w-28 mx-auto" width="410" height="65" priority>
    </a>

    <ng-container *ngIf="status === 'form'">
      <h2 class="text-2xl font-bold text-primary mb-2">Set a new password</h2>
      <p class="text-text-secondary mb-6">Choose a new password for your account.</p>

      <form class="grid gap-2 text-left" [formGroup]="resetForm">
        <mat-form-field class="full-width" appearance="fill">
          <mat-label>New password</mat-label>
          <input #passwordInput matInput autocomplete="new-password" type="password" formControlName="password"
            placeholder="Minimum of 6 characters" />
          <button matSuffix mat-icon-button type="button"
            aria-label="Toggle password visibility" (click)="togglePasswordInputIcon()">
            <mat-icon>{{ passwordInputIcon }}</mat-icon>
          </button>
          <mat-hint align="start">Minimum of 6 characters</mat-hint>
          <mat-error *ngIf="
              resetForm.controls.password.hasError('minlength') &&
              !resetForm.controls.password.hasError('required')
            ">
            Please exceed 6 characters
          </mat-error>
          <mat-error *ngIf="resetForm.controls['password'].hasError('required')">
            Password is <strong>required</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" appearance="fill">
          <mat-label>Confirm new password</mat-label>
          <input #confirmPasswordInput matInput autocomplete="new-password" type="password" formControlName="confirmPassword"
            placeholder="" />
          <button matSuffix mat-icon-button type="button"
            aria-label="Toggle password visibility" (click)="toggleConfirmPasswordInputIcon()">
            <mat-icon>{{ confirmPasswordInputIcon }}</mat-icon>
          </button>
          <mat-error *ngIf="resetForm.controls['confirmPassword'].hasError('required')">
            Please confirm your password
          </mat-error>
          <mat-error *ngIf="
              !resetForm.controls['confirmPassword'].hasError('required') &&
              resetForm.hasError('mismatch') &&
              resetForm.controls['confirmPassword'].touched
            ">
            Passwords don't match
          </mat-error>
        </mat-form-field>

        <app-progress-button type="submit" class="mt-4" (click)="submit()"
          buttonText="Reset password" [loading]="isSubmitting"
          [disabled]="resetForm.invalid || isSubmitting"></app-progress-button>
      </form>
    </ng-container>

    <ng-container *ngIf="status === 'success'">
      <mat-icon class="!text-5xl !w-auto !h-auto text-primary">check_circle</mat-icon>
      <h2 class="text-2xl font-bold text-primary mt-4 mb-2">Password reset</h2>
      <p class="text-text-secondary mb-6">{{ message }}</p>
      <a routerLink="/login" class="btn-accent">Continue to login</a>
    </ng-container>

    <ng-container *ngIf="status === 'error'">
      <mat-icon class="!text-5xl !w-auto !h-auto text-red-600">error</mat-icon>
      <h2 class="text-2xl font-bold text-primary mt-4 mb-2">Reset failed</h2>
      <p class="text-text-secondary mb-6">{{ message }}</p>
      <a routerLink="/forgot-password" class="btn-accent">Request a new link</a>
    </ng-container>
  </div>
</div>
